/**
 * COMPOSANT   : OfflineIndicator
 * OBJECTIF    : Barre discrète en bas d'écran indiquant l'état hors-ligne,
 *               le nombre d'actions en attente, la synchronisation en
 *               cours et le dernier succès.
 * ARCHITECTURE: S'abonne à offlineQueue.subscribe.
 * API PROPS   : className?, testId?
 */
import React, { useEffect, useState } from "react";
import { CloudOff, Loader2, CheckCircle2, RefreshCw } from "lucide-react";
import offlineQueue from "@/lib/offlineQueue";

export default function OfflineIndicator({ className = "", testId = "offline-indicator" }) {
  const [state, setState] = useState(offlineQueue.getState());

  useEffect(() => {
    return offlineQueue.subscribe(setState);
  }, []);

  const shouldShow = !state.isOnline || state.pending > 0 || state.syncing;
  if (!shouldShow) return null;

  return (
    <div
      className={`fixed bottom-4 left-1/2 -translate-x-1/2 z-40 rounded-full px-4 py-2 text-sm font-medium shadow-lg border ${
        !state.isOnline
          ? "bg-slate-800 text-white border-slate-700"
          : state.syncing
            ? "bg-blue-50 text-blue-700 border-blue-200"
            : "bg-amber-50 text-amber-800 border-amber-200"
      } ${className}`}
      data-testid={testId}
    >
      <div className="flex items-center gap-2">
        {!state.isOnline && <><CloudOff className="w-4 h-4" /> Hors ligne</>}
        {state.isOnline && state.syncing && <><Loader2 className="w-4 h-4 animate-spin" /> Synchronisation…</>}
        {state.isOnline && !state.syncing && state.pending > 0 && (
          <><RefreshCw className="w-4 h-4" /> {state.pending} en attente</>
        )}
        {state.pending > 0 && !state.syncing && (
          <button
            onClick={() => offlineQueue.flush()}
            className="ml-2 text-xs underline"
            data-testid={`${testId}-sync-now`}
          >
            Synchroniser
          </button>
        )}
      </div>
    </div>
  );
}
